"use client"

import { useLocale, useTranslations } from "next-intl"
import { TIcon } from "../../ui/display/TIcon"
import { TMenu } from "../../ui/menu/TMenu"
import { TMenuItem } from "../../ui/menu/TMenuItem"
import { tWithFallback } from "../utils/i18n"

interface ImageUploadMenuProps {
	onDeviceUpload: () => void
	onWorkHistoryUpload?: () => void | Promise<void>
	children: React.ReactNode | ((props: { open?: boolean }) => React.ReactNode)
	/** 메뉴 방향 — 소비자(앱)가 브레이크포인트에 맞게 결정 */
	menuSide?: "right" | "bottom"
}

/**
 * 업로드 소스 선택 메뉴 (from Device / from Work History)
 *
 * @note 이미지 전용 로직은 없다 — 영상 필드(video_url·video_urls)도 그대로 쓴다.
 * TODO: 이름이 실제 역할보다 좁다. MediaUploadMenu로 rename (소비처 6곳 동반 수정 필요).
 */
export function ImageUploadMenu({ onDeviceUpload, onWorkHistoryUpload, children, menuSide = "right" }: ImageUploadMenuProps) {
	const t = useTranslations()
	const locale = useLocale()
	return (
		<TMenu
			side={menuSide}
			renderButton={({ open }) => (typeof children === "function" ? children({ open }) : children)}
			renderMenu={({ onClose }) => (
				<div className="flex flex-col">
					<TMenuItem
						label={tWithFallback(t, locale, "creagen.ai.upload.fromDevice", "from Device")}
						prefix={<TIcon name="upload" />}
						onClick={(e) => {
							e.stopPropagation()
							onDeviceUpload()
							onClose()
						}}
					/>
					{onWorkHistoryUpload && (
						<TMenuItem
							label={tWithFallback(t, locale, "creagen.ai.upload.fromWorkHistory", "from Work History")}
							prefix={<TIcon name="recentlyViewed" />}
							onClick={(e) => {
								e.stopPropagation()
								onWorkHistoryUpload()
								onClose()
							}}
						/>
					)}
				</div>
			)}
		/>
	)
}
